import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BreadcrumbModule } from '@commons/breadcrumb/breadcrumb.module';
import { FooterModule } from '@commons/footer/footer.module';
import { HeaderModule } from '@commons/header/header.module';
import { LinkModule } from '@commons/link/link.module';
import { PipeModule } from '@commons/pipe/pipe.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TabBarModule } from '@commons/tab-bar/tab-bar.module';
import { DirectoryModule } from '@domains/directory/directory.module';
import { JobModule } from '@domains/job/job.module';
import { CompanyLayoutComponent } from '@features/directories/company-layout/company-layout.component';
import { CompaniesComponent } from '@features/directories/company-layout/contents/companies/companies.component';
import { JobsCitiesComponent } from '@features/directories/job-layout/contents/jobs-cities/jobs-cities.component';
import { JobsDomainsComponent } from '@features/directories/job-layout/contents/jobs-domains/jobs-domains.component';
import { JobsComponent } from '@features/directories/job-layout/contents/jobs/jobs.component';
import { JobLayoutComponent } from '@features/directories/job-layout/job-layout.component';
import { JobsListComponent } from '@features/directories/job-layout/jobs-list/jobs-list.component';
import { DirectoriesRoutingModule } from '@routing/directories/directories-routing.module';
import { SeoStoreModule } from '@store/seo/seo.store.module';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';
import { JobsContractsComponent } from '@features/directories/job-layout/contents/jobs-contracts/jobs-contracts.component';

@NgModule({
  imports: [
    CommonModule,
    DirectoryModule,
    DirectoriesRoutingModule,
    HeaderModule,
    FooterModule,
    TabBarModule,
    PipeModule,
    LinkModule,
    JobModule,
    SvgIconModule,

    SeoStoreModule,

    HeadTitleModule,
    HeadDescriptionModule,
    BreadcrumbModule,
  ],
  declarations: [
    CompanyLayoutComponent,
    JobLayoutComponent,
    CompaniesComponent,
    JobsComponent,
    JobsListComponent,
    JobsCitiesComponent,
    JobsDomainsComponent,
    JobsContractsComponent,
  ],
})
export class DirectoriesModule {}
